import React from 'react';
import appLogo from 'src/assets/images/app-logo.png';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { BaseTypography } from '../../components/common/BaseTypography/BaseTypography';
import bgImg from './bg.png';
import spcLogo from './Singapore-logo.jpg';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { ContactUsFormContainer } from './ContactUsForm/ContactUsFormContainer';
import clsx from 'clsx';

const tcUrl = APP_ROUTES.TERMS_AND_CONDITIONS;
const ppUrl = APP_ROUTES.PRIVACY_POLICY;

const useStyles = makeStyles((theme) => ({
  root: {
    background: `url(${bgImg})`,
    padding: '20px 0',
    backgroundSize: 'cover',
  },
  body: {
    display: 'grid',
    gridTemplateColumns: 'max-content 730px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  block__logoSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
	  marginBottom: '40px',
      order: '2',
    },
  },
  block__logo: {
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '15px',
	  marginTop: '20px',
    },
  },
  footIcon: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '5px'
  }, 
  truspilot:{
		margin: "20px 0"
	},
	memberLogo: {
		marginBottom: "15px",
	}
}));

export const ContactUsFooter: React.FC<any> = (props) => {
  const { className, ...otherProps } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const url = window.location.pathname;

  const footer = 
  (url !== APP_ROUTES.SURVEY_FORM  && url !== APP_ROUTES.GTAG_LANDING && url !== APP_ROUTES.THANK_YOU && url !== APP_ROUTES.EXPERT) ? (
    <div className={clsx(classes.root, className)} {...otherProps}>
      <div className={commonClasses.container}>
		<div className={`${classes.truspilot} `} >
			<div 
			  className="trustpilot-widget"
			  data-locale="en-GB" 
			  data-template-id="5419b6a8b0d04a076446a9ad" 
			  data-businessunit-id="647f5da670edebc1c8cdd6e4" 
			  data-style-height="24px" 
			  data-style-width="100%" 
			  data-theme="light" 
			  data-min-review-count="10" 
			  data-without-reviews-preferred-string-id="1" 
			  data-style-alignment="left">
			  <a href="https://www.trustpilot.com/review/contactsbook.media">Trustpilot</a>
			</div>
		</div>
        <div className={classes.body}>
          <div className={classes.block__logoSection}>
            <div className={classes.block__logo}>
              <img src={appLogo} alt="ContactsBook Logo" />
            </div>
			<BaseTypography className={classes.memberLogo} variant="text">
				A member of:<br />
				<a aria-label="SPC Logo"
				href="https://pressclub.org.sg/"
				target="_blank"
				rel="noreferrer"><img style={{ marginTop: '5px' }} width="180" height="58" src={spcLogo} alt="SPC Logo" /></a>
            </BaseTypography>

            <div className={classes.footIcon}>
			  <a  aria-label="Linkedin"
				href="https://www.linkedin.com/company/79170993/admin/"
				target="_blank"
				rel="noreferrer">
				<svg
				  xmlns="http://www.w3.org/2000/svg"
				  width="24"
				  height="24"
				  viewBox="0 0 24 24">
				  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
				</svg>
			  </a>
			  <a  aria-label="Facebook"
			  href="https://www.facebook.com/contactsbook.asia"
			  target="_blank"
			  rel="noreferrer">
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 24 24"><path d="M17,3H7C4.791,3,3,4.791,3,7v10c0,2.209,1.791,4,4,4h5.621v-6.961h-2.343v-2.725h2.343V9.309 c0-2.324,1.421-3.591,3.495-3.591c0.699-0.002,1.397,0.034,2.092,0.105v2.43h-1.428c-1.13,0-1.35,0.534-1.35,1.322v1.735h2.7 l-0.351,2.725h-2.365V21H17c2.209,0,4-1.791,4-4V7C21,4.791,19.209,3,17,3z"/></svg>
			  </a>
			  <a  aria-label="Twitter"
			  href="https://x.com/contactsbook_a"
			  target="_blank"
			  rel="noreferrer">
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 24 24"><path d="M10.053,7.988l5.631,8.024h-1.497L8.566,7.988H10.053z M21,7v10	c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V7c0-2.209,1.791-4,4-4h10C19.209,3,21,4.791,21,7z M17.538,17l-4.186-5.99L16.774,7	h-1.311l-2.704,3.16L10.552,7H6.702l3.941,5.633L6.906,17h1.333l3.001-3.516L13.698,17H17.538z"/></svg>
			  </a>
			  <a  aria-label="Youtube"
			  href="https://www.youtube.com/@ContactsBookasia"
			  target="_blank"
			  rel="noreferrer">
				  <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">    <path d="M 15 4 C 10.814 4 5.3808594 5.0488281 5.3808594 5.0488281 L 5.3671875 5.0644531 C 3.4606632 5.3693645 2 7.0076245 2 9 L 2 15 L 2 15.001953 L 2 21 L 2 21.001953 A 4 4 0 0 0 5.3769531 24.945312 L 5.3808594 24.951172 C 5.3808594 24.951172 10.814 26.001953 15 26.001953 C 19.186 26.001953 24.619141 24.951172 24.619141 24.951172 L 24.621094 24.949219 A 4 4 0 0 0 28 21.001953 L 28 21 L 28 15.001953 L 28 15 L 28 9 A 4 4 0 0 0 24.623047 5.0546875 L 24.619141 5.0488281 C 24.619141 5.0488281 19.186 4 15 4 z M 12 10.398438 L 20 15 L 12 19.601562 L 12 10.398438 z"/></svg>
			  </a>
			  <a  aria-label="Instagram"
			  href="https://instagram.com/contactsbook.asia"
			  target="_blank"
			  rel="noreferrer">
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 30 30"><path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"/></svg>
			  </a>
			</div>
            
            <div>
              <BaseTypography variant="text">
                Powered by Hong Bao Media
              </BaseTypography>
              <BaseTypography variant="text">
                ©2026 All rights reserved.
              </BaseTypography>
              <BaseTypography variant="text">
                138 Robinson Road<br /> #21-02 Oxley Tower Lobby 1,<br /> Singapore 068906 <br /> (+65) 62232249
              </BaseTypography>
			  
			  <BaseTypography variant="text">
				<a href={tcUrl}>Terms and Conditions</a> | <a href={ppUrl}>Privacy Policy</a>
              </BaseTypography>
            </div>
          </div>

          <div style={{ position: 'relative' }}>
            <ContactUsFormContainer isVerticalForm={isMobile} />
          </div>
        </div>
      </div>
    </div>
  ) : (
	<>
	</> 
  )
  return footer;
};
